export default "__VITE_ASSET__f3d642af__"